
export default function () {

  return {
    // item: null,
    // tempItem: null,
    // items: [],
    // skip: 0,
    limit: 12,
    // total: 0,
    orderBy: 'internalId',
    // orderDesc: false,
    searchBy: ['title', 'internalId', 'inn', 'address'],
    // searchQuery: '',
    // where: {},
    // loading: false,
    include: ['city', 'campaign'],
    // fields: [],
  };
}
